import {
  getHamburgerItem as getItems,
  hamburgerItemList as itemList,
  HamburgerItems,
} from './constants'
import Hamburger, { Hamburger as HamburgerMenu } from './hamburger'

export const getHamburgerItem = getItems
export const HamEnum = HamburgerItems
export const getHamburgerList = itemList

export const DisconnectedHamburger = HamburgerMenu
export default Hamburger
